/*
 * This file is generated by the workex CLI Tool
 *
 * Please visit https://workex.pistonite.dev for more information
 */

import type { WxProtocolBindConfig } from "@pistonite/workex";
import type { Runtime } from "../runtime_api.ts";
import type { RuntimeApp } from "../runtime_app.ts";
import { _wxRecverImpl } from "./RuntimeApp.ts";
import { _wxSenderImpl } from "./Runtime.ts";

/**
 * Create a bind config for the Runtime interface, under the `skybapi-0.0.7` protocol
 *
 * When used with a creator function in Workex, an implementation of Runtime will be returned
 * to send remote calls to the other side. This side needs to provide an implementation for RuntimeApp
 * to be used when the other side calls this side
 *
 * This function is generated by the workex CLI tool
 */
export const skybookRuntime = (handler: RuntimeApp, resolve?: (_: Runtime) => (void | Promise<void>)): WxProtocolBindConfig<Runtime> => { return {
    protocol: "skybapi-0.0.7",
    interfaces: ["Runtime", "RuntimeApp"],
    recvHandler: _wxRecverImpl(handler),
    bindSend: (sender) => {
        const impl = new _wxSenderImpl(sender);
        resolve?.(impl);
        return impl;
    },
}};